var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"axis block-color",class:{ 'horizontal': !_vm.vertical }},_vm._l((_vm.values),function(dash,i){return _c('div',{key:dash.value,staticClass:"dash block-color",class:[dash.type, { 'hidden': dash.value === 0 }],style:({ top: (((i) * _vm.step) + "px") }),attrs:{"data-value":dash.type && dash.value}})}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-699c7655","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/UI/Grid/Axis.vue
// module id = null
// module chunks = 